/** @module csi/datasheet/TemplateSnapshotRenderer */
define([
	"dojo/_base/declare",
	"dojo/dom-class",
	"dojo/topic",
	"underscore",
	"csi/heading/AttributeAction",
	"csi/heading/RefImage",
	"csi/image/LightGalleryController",
	"csi/model/image",
], function(declare, domClass, topic, _, AttributeAction, RefImage, LightGalleryController, {getImageData}) {

	const PATH_TO_SNAPSHOTS = "Child:__Parent__/Child:Pages/Child:Snapshot";

	const _Controller = declare(LightGalleryController, {
		/**
		 * @override
		 * Return data for all pages of the template
		 */
		_getImages() {
			const page = this.getNode();
			const snapshots = this.m_cache.getPathNodes(page, PATH_TO_SNAPSHOTS);
			const images = snapshots.map((snapshot) => getImageData(snapshot));
			return [images, 0];
		}
	});

	const CanvasTemplatePagesView = declare(AttributeAction, {
		constructor(def) {
			this.m_id = "CanvasTemplatePageView";
			this.classController = _Controller;
		}
	});

	return declare(RefImage, {
		/**
		 * @override
		 * Use custom tooltip action to view all canvas template snapshots
		 */
		_getTooltipActions(ctx, h, bBrowse) {
			return [this._mixinTooltipAction(new CanvasTemplatePagesView(), h, true)];
		},

		/**
		 * @override
		 * Use generic icon for templates with missing snapshots
		 */
		toHtmlStatic(ctx, h, refNode, actionData) {
			const node = ctx.getNode();

			if (node?.ThumbnailGenerated == false) {
				domClass.add(refNode, "csiGalleryNoImage csiActionIcon iconSaveTemplate");
				topic.publish("/csi/refimage/draw", ctx, h, refNode, "", false);
				return true;
			}

			return this.inherited(arguments);
		},

		/**
		 * @override
		 * Don't display tooltip for templates with missing snapshots
		 */
		toTooltip(ctx, h, tooltip) {
			const node = ctx.getNode();

			if (node?.ThumbnailGenerated) {
				return this.inherited(arguments);
			}
		}
	});
});